class MobileMenu {
  constructor(el) {
    this.el = el;
    this.open = 0;
    this.bind();
  }

  bind() {
    this.el.addEventListener('click', () => this.toggle());
  }

  toggle() {
    this.el.classList.remove('is-open', 'is-closed');
    if ( this.open ) {
      this.el.classList.add('is-closed');
    } else {
      this.el.classList.add('is-open');
    }
    this.open = ! this.open;
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./scripts/components/mobilemenu.js